import React from "react";

export function PageHeader({ eyebrow, title, subtitle, actions, testid }) {
  return (
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-6" data-testid={testid}>
      <div>
        {eyebrow && (
          <div className="text-[11px] uppercase tracking-[0.18em] font-heading font-bold text-[var(--hms-accent)] mb-1">
            {eyebrow}
          </div>
        )}
        <h1 className="font-heading text-2xl md:text-3xl font-extrabold tracking-tight">{title}</h1>
        {subtitle && <p className="text-sm text-[var(--hms-text-2)] mt-1 max-w-2xl">{subtitle}</p>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </div>
  );
}

export function StatusBadge({ status }) {
  const map = {
    admitted:    { label: "Admitted",    cls: "bg-[#588157]/15 text-[#588157] border-[#588157]/30" },
    ipd:         { label: "Admitted",    cls: "bg-[#588157]/15 text-[#588157] border-[#588157]/30" },
    opd:         { label: "OPD",         cls: "bg-[#F4A261]/15 text-[#b96b27] border-[#F4A261]/30" },
    registered:  { label: "Registered",  cls: "bg-[#0B132B]/8 text-[#0B132B] border-[#0B132B]/20" },
    discharged:  { label: "Discharged",  cls: "bg-[#C8553D]/15 text-[#C8553D] border-[#C8553D]/30" },
  };
  const v = map[status] || { label: status || "—", cls: "bg-[#6C757D]/15 text-[#6C757D] border-[#6C757D]/30" };
  return (
    <span className={`px-2 py-0.5 rounded-sm text-[10px] font-bold uppercase tracking-widest border ${v.cls} font-heading`}>
      {v.label}
    </span>
  );
}

export function StatCard({ label, value, accent = false, testid }) {
  return (
    <div
      className={`hms-card p-4 flex flex-col gap-1 ${accent ? "border-[var(--hms-accent)]/40" : ""}`}
      data-testid={testid}
    >
      <div className="hms-section-title">{label}</div>
      <div className={`hms-stat text-3xl ${accent ? "text-[var(--hms-accent)]" : ""}`}>{value}</div>
    </div>
  );
}

export function EmptyState({ title, hint, action }) {
  return (
    <div className="hms-card p-10 text-center">
      <div className="font-heading font-bold text-base mb-1">{title}</div>
      {hint && <div className="text-sm text-[var(--hms-text-2)] mb-4">{hint}</div>}
      {action}
    </div>
  );
}

export function FieldGrid({ children, cols = 3 }) {
  const cls = cols === 2 ? "grid-cols-1 md:grid-cols-2" : "grid-cols-1 md:grid-cols-2 lg:grid-cols-3";
  return <div className={`grid ${cls} gap-4`}>{children}</div>;
}

export function KV({ label, value, testid }) {
  return (
    <div data-testid={testid}>
      <div className="text-[10px] uppercase tracking-wider font-bold text-[var(--hms-muted)]">{label}</div>
      <div className="text-sm font-medium">{value || <span className="text-[var(--hms-muted)]">—</span>}</div>
    </div>
  );
}
